/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T17:22:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-05T16:42:08-07:00
*/



import React from 'react';
import glamorous from 'glamorous';
import { box, dimensions, spacing } from '../../style';

const StyleList = glamorous.ul({
  ...spacing.MARGIN_V_SM,
  ...spacing.PADDING_0,
  backgroundColor: '#FFF',

  [dimensions.SCREEN_MIN_MD]: {
    ...box
  }
});

const ResultList = (props) =>  {
    return (
      <StyleList>
        {props.children}
      </StyleList>
    );
}

export default ResultList;



// WEBPACK FOOTER //
// ./src/components/blocks/ResultList.jsx